import BaseDrawingObject from "./baseDrawingObject";

class Text extends BaseDrawingObject {

    constructor(text, positionX, positionY, optionalFormattingFunc, optionalColour, optionalStyle) {
        super();
        this.text = text;
        this.position = { x: positionX, y: positionY };
        this.formattingFunc = optionalFormattingFunc;
        this.colour = optionalColour;
        this.type = 'text';
        this.style = optionalStyle;
    }

    getDisplayText() {
        if (this.formattingFunc) {
            return this.formattingFunc(this.text);
        } else {
            return this.text;
        }
    }
    // setDrawingGroupName(group) {
    //     this.drawingGroupName = group;
    //     return this;
    // }
    setBackgroundColour(bgColour) {
        this.backgroundColour = bgColour;
        return this;
    }
    setBackgroundWidth(width) {
        this.backgroundWidth = width;
        return this;
    }
    setBackgroundHeight(height) {
        this.backgroundHeight = height;
        return this;
    }
    setRotationAngle(angle) {
        this.rotationAngle = angle;
        return this;
    }
    setAnchorPoint(point) {
        this.anchorPoint = point;
        return this;
    }
}



export default Text;

